// extracted by mini-css-extract-plugin
module.exports = {"dl":"Dl_dl__37y1p"};